const ofertaCGU = () => {
  let infoCA = {
    oferta: [
      {
        label: "Cuenta Gratuita Universal",
        description: ""
      },
      {
        label: "Tarjeta <strong>Visa Débito</strong>",
        description: ""
      }
    ]
  };

  return infoCA;
};

export default ofertaCGU;
